import Type from "@/model/types/Type";


const type = {
    SEND_MAIL: 1,
    GENERATE_LABEL_AND_SEND_PRINTER_DEFAULT: 2,
    STOCK_PRODUCT_IN: 3,
    STOCK_PRODUCT_OUT: 4,
    GENERATE_REPORT_QUALITY: 5,
    REMOVE_NON_CONFORMANCE: 6,
}

const list = [
    {
        value: type.SEND_MAIL,
        text: "Envio de e-mail",
    },
    {
        value: type.GENERATE_LABEL_AND_SEND_PRINTER_DEFAULT,
        text: "Emissão e impressão de etiqueta",

    },
    {
        value: type.STOCK_PRODUCT_IN,
        text: "Entrada mp estoque de produto",

    },
    {
        value: type.STOCK_PRODUCT_OUT,
        text: "Saída no estoque de produto",

    },
    {
        value: type.GENERATE_REPORT_QUALITY,
        text: "Emissão de laudo de qualidade",

    },
    {
        value: type.REMOVE_NON_CONFORMANCE,
        text: "Remover tipo de conformidade geral",

    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}


export default {
    type,
    list,
    contains,
}